import { render, staticRenderFns } from "./Mitteilungen.vue?vue&type=template&id=4ba98498&scoped=true&"
import script from "./Mitteilungen.vue?vue&type=script&lang=js&"
export * from "./Mitteilungen.vue?vue&type=script&lang=js&"
import style0 from "./Mitteilungen.vue?vue&type=style&index=0&id=4ba98498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba98498",
  null
  
)

export default component.exports